import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import CandidateResume from '@/components/CandidateResume';
import CandidateSearch from '@/components/CandidateSearch';
import TopPageLinks, { PageLink } from '@/components/TopPageLinks';
import { Candidate } from '@/services/candidates';
import { Paths } from '@/types/routes';
import { PageHeader } from './Candidate.styles';

type Props = PropsWithChildren<{
  topPageLinks: PageLink[];
  refetchCandidateData: () => void;
  fullCandidate?: Candidate;
  isNotesPage?: boolean;
  isTalentPool?: boolean;
}>;

const CandidatePage = ({
  topPageLinks,
  refetchCandidateData,
  fullCandidate,
  isNotesPage,
  isTalentPool,
  children,
}: Props): JSX.Element => {
  return (
    <>
      <PageHeader>
        <TopPageLinks
          pageLinks={topPageLinks}
          backTo={isTalentPool ? Paths.TALENT_POOL : Paths.CANDIDATES}
        />
        <CandidateSearch />
      </PageHeader>
      <CandidateResume
        refetchCandidate={refetchCandidateData}
        isNotesPage={isNotesPage}
        candidate={fullCandidate}
      />
      <Outlet />
      {children}
    </>
  );
};

export default CandidatePage;
